<template>
<v-card :loading="loading" :disabled="loading">
  <CardTitle :title="title ? 'Addresses: '+ title : 'Addresses'">
    <template v-slot:prepend_actions>
      <Address :customer_id="customer_id"></Address>
    </template>
    <template v-slot:actions>
      <slot name="title_actions"></slot>
      <v-tooltip bottom>
        <template v-slot:activator="{on}">
          <v-btn v-on="on" @click="loadData" icon><v-icon>mdi-refresh</v-icon></v-btn>
        </template>
        <span>Reload Data</span>
      </v-tooltip>
    </template>
  </CardTitle>
  <v-card-text>
    <v-list>
      <template v-for="(item, index) in items">
        <v-list-item :key="item.id" two-line>
          <v-list-item-content>
            <v-list-item-title>Type</v-list-item-title>
            <v-list-item-subtitle>{{item.address_type.desc}}</v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-content>
            <v-list-item-title>Address</v-list-item-title>
            <v-tooltip bottom>
              <template v-slot:activator="{on}">
                <v-list-item-subtitle v-on="on">
                  <a :href="`https://google.com/maps/search/${item.street},${item.city},${item.state},${item.zipcode}`" target="_blank">
                    {{item.street}},
                    {{item.city}},
                    {{item.state}},
                    {{item.zipcode}}
                  </a>
                </v-list-item-subtitle>
              </template>
              <span>
                  {{item.street}},
                  {{item.city}},
                  {{item.state}},
                  {{item.zipcode}}
                </span>
            </v-tooltip>
          </v-list-item-content>
          <v-spacer></v-spacer>
          <v-list-item-content class="hidden-sm-and-down">
            <v-list-item-title>+4</v-list-item-title>
            <v-list-item-action-text>
              {{item.zipcodepf ? item.zipcodepf : "n/a"}}
            </v-list-item-action-text>
          </v-list-item-content>
          <v-list-item-content>
            <v-list-item-title>Region</v-list-item-title>
            <v-list-item-action-text>
              {{item.region_type.desc}}
            </v-list-item-action-text>
          </v-list-item-content>
          <v-list-item-action>
            <Address editing :customer_id="customer_id" :data="item"></Address>
          </v-list-item-action>
        </v-list-item>
        <v-divider v-if="index + 1 !== items.length" :key="index+ '-' + item.id"></v-divider>
      </template>
    </v-list>
  </v-card-text>
  <slot name="actions"></slot>
</v-card>
</template>

<script>
export default {
name: "Addresses",
  components:{
    Address: () => import( "@/views/DirectoryV2/components/forms/Address")
  },
  data: () => ({
    loading: false,
  }),
  props:{
    customer_id: {
      required: true,
    },
    title:{
      required: false,
    }
  },
  computed: {
    items(){
      return this.$store.$db().model('addresses').query().where('customer_id', this.customer_id).with(['region_type','address_type']).all();
    }
  },
  watch:{
    customer_id(){
      if(!this.loading){
        this.loadData();
      }
    }
  },
  mounted(){
    if(!this.loading){
      this.loadData();
    }
  },
  methods:{
    async loadData(){
      this.extraData();
      this.loading = true;
      try{
        await this.$store.$db().model('addresses').api().fetch({
          where: {
            key: "customer_id",
            value: this.customer_id
          },
          with: "regionType,addressType"
        });
      }catch(err){
        this.$store.dispatch("showError", "Failed to load data.")
      } finally {
        this.loading = false;
      }
    },
    extraData(){
      this.$store.$db().model('addressTypes').api().fetch();
      this.$store.$db().model('regionTypes').api().fetch();
    }
  }
}
</script>

<style scoped>

</style>
